import React from "react";
import { Result, Button } from "antd";

// Without this, an uncaught render error anywhere under /crm unmounts the
// whole tree and leaves a blank white screen with no indication of what
// went wrong (e.g. passing null instead of [] to an antd Upload fileList).
//
// `resetKey` (pass the route pathname) clears a stuck error via a plain
// state update when the user navigates away — NOT via the `key` prop on
// this component, which would force a full unmount/remount of the whole
// CRM subtree (layout, lazy chunk, everything) on every single route
// change and cause a visible white flash.
class CrmErrorBoundary extends React.Component {
    state = { hasError: false };

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error("CRM render error:", error, info);
    }

    componentDidUpdate(prevProps) {
        if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
            this.setState({ hasError: false });
        }
    }

    render() {
        if (this.state.hasError) {
            return (
                <Result
                    status="error"
                    title="Something went wrong"
                    subTitle="This page hit an unexpected error. Try reloading — if it keeps happening, contact support."
                    extra={
                        <Button type="primary" onClick={() => window.location.reload()}>
                            Reload
                        </Button>
                    }
                />
            );
        }
        return this.props.children;
    }
}

export default CrmErrorBoundary;
